































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import { Drawer } from 'element-ui';
@Component({
  name: 'lb-drawer'
  // components: {
  //   'ElDrawer': Drawer
  // }
})
export default class extends Vue {
  @Prop() private type!: string;
  @Prop({type: Boolean, default: false}) private visible!: boolean;
  @Prop({default: ''}) private title!: string;
  @Prop({
    default: 'rtl',
    validator(val) {
      return ['rtl', 'ltr', 'ttb', 'btt'].indexOf(val) !== -1;
    }
  }) private direction!: string;
  @Prop({default: '30%'}) private size!: string | number;
  @Prop({type: Boolean, default: true}) private modal!: boolean;
  @Prop({type: Boolean, default: true}) private modalAppendToBody!: boolean;
  @Prop({type: Boolean, default: false}) private appendToBody!: boolean;
  @Prop({type: Boolean, default: false}) private closeOnClickModal!: boolean;
  @Prop({type: Boolean, default: false}) private closeOnPressEscape!: boolean;
  @Prop({type: Boolean, default: true}) private showClose!: boolean;
  @Prop({type: Boolean, default: true}) private showTitle!: boolean;
  @Prop({default: ''}) private customClass!: string;
  @Prop({type: Boolean, default: true}) private wrapperClosable!: boolean;
  @Prop() private beforeClose!: any;

  private localVisible: boolean = this.visible;
  private localCustomClass: string = 'lb-drawer--custom';

  created() {
    if (this.customClass) {
      this.localCustomClass += ' ' + this.customClass;
    }
  }

  private handleOpen() {
    this.$emit('open');
  }

  private handleClose() {
    this.localVisible = false;
    this.$emit('close');
  }

  private handleOpened() {
    this.$emit('opened');
  }

  private handleClosed() {
    this.$emit('closed');
  }

  @Watch('visible')
  private onVisibleChange(visible: boolean) {
    this.localVisible = visible;
  }

  @Watch('localVisible')
  private onLocalVisibleChange(visible: boolean) {
    this.$emit('update:visible', visible);
  }
}
